import {
  REQUEST_COMPANIES,
  RECEIVED_COMPANIES,
  SHOW_ADD_COMPANY_FORM,
  CLOSE_ADD_COMPANY_FORM,
  UPDATE_COMPANY_SUCCEDED,
  DELETE_COMPANY_SUCCEDED,
  UPDATE_COMPANY_FIELD,
  SHOW_ERROR_COMPANIES,
  CHANGE_PAGE
} from '../actions/companies'

import { RECEIVED_BUILDINGS } from '../actions/buildings'

const companiesReducer = (state = {}, action) => {
  switch (action.type) {
    case REQUEST_COMPANIES:
      return {
        ...state,
        isFetching: true
      }
    case RECEIVED_COMPANIES:
      return {
        ...state,
        isFetching: false,
        companiesFetched: true, 
        companies: action.json.companies,
        companiesCount: action.json.companiesCount,
        pageChanged: false,
        error: null
      }
    case RECEIVED_BUILDINGS:
      return {
        ...state,
        isFetching: false,
        buildingsFetched: true,
        buildings: action.json.buildings
      }
    case SHOW_ADD_COMPANY_FORM:
      return {
        ...state,
        company: action.company
      }
    case CLOSE_ADD_COMPANY_FORM:
      return {
        ...state,
        company: null,
        error: null
      }
    case UPDATE_COMPANY_FIELD:
      return {
        ...state,
        company: { ...state.company, [action.name]: action.value },
        event: null,
        building: null,
        error: null
      }
    case SHOW_ERROR_COMPANIES:
      return {
        ...state,
        error: action.error
      }

    case UPDATE_COMPANY_SUCCEDED:
      let newCompanies = state.companies.filter((company) => {
        return company._id !== action.company._id
      })

      newCompanies.push(action.company)

      return {
        ...state,
        company: null,
        companies: newCompanies,
        error: null
      }

    case DELETE_COMPANY_SUCCEDED:
      return {
        ...state,
        company: null,
        companies: state.companies.filter((company) => {
          return company._id !== action.company._id
        })
      }

    case CHANGE_PAGE:
      return {
        ...state,
        pageNumber: action.pageNumber,
        pageChanged: true
      }

    default:
      return {
        ...state
      }
  }
}

export default companiesReducer



// WEBPACK FOOTER //
// ./src/reducers/companies.js